import { collapseItemProps as D } from "./index613.js";
import { defineComponent as $, openBlock as v, createElementBlock as g, normalizeClass as s, unref as e, createElementVNode as a, withKeys as A, withModifiers as N, renderSlot as n, createTextVNode as S, toDisplayString as T, createVNode as C, withCtx as y, createBlock as V, resolveDynamicComponent as F, withDirectives as H, vShow as M } from "vue";
import { ElCollapseTransition as z } from "./index617.js";
import { ElIcon as O } from "./index538.js";
import { useCollapseItem as P, useCollapseItemDOM as W } from "./index730.js";
const j = ["id", "aria-expanded", "aria-controls", "aria-describedby", "tabindex", "aria-disabled"], q = ["id", "aria-hidden", "aria-labelledby"];
var U = /* @__PURE__ */ $({
  name: "ElCollapseItem",
  __name: "collapse-item",
  props: D,
  setup(t, { expose: K }) {
    const c = t, {
      focusing: m,
      id: w,
      isActive: l,
      handleFocus: p,
      handleHeaderClick: u,
      handleEnterClick: b
    } = P(c), {
      arrowKls: I,
      headKls: h,
      rootKls: k,
      itemTitleKls: x,
      itemWrapperKls: E,
      itemContentKls: B,
      scopedContentId: d,
      scopedHeadId: f
    } = W(c, { focusing: m, isActive: l, id: w });
    return K({
      /** @description current collapse-item whether active */
      isActive: l
    }), (r, i) => (v(), g(
      "div",
      {
        class: s(e(k))
      },
      [
        a("div", {
          id: e(f),
          class: s(e(h)),
          "aria-expanded": e(l),
          "aria-controls": e(d),
          "aria-describedby": e(d),
          tabindex: t.disabled ? void 0 : 0,
          "aria-disabled": t.disabled,
          role: "button",
          onClick: i[0] || (i[0] = //@ts-ignore
          (...o) => e(u) && e(u)(...o)),
          onKeydown: i[1] || (i[1] = A(N(
            //@ts-ignore
            (...o) => e(b) && e(b)(...o),
            ["stop"]
          ), ["space", "enter"])),
          onFocus: i[2] || (i[2] = //@ts-ignore
          (...o) => e(p) && e(p)(...o)),
          onBlur: i[3] || (i[3] = (o) => m.value = !1)
        }, [
          a(
            "span",
            {
              class: s(e(x))
            },
            [
              n(r.$slots, "title", { isActive: e(l) }, () => [
                S(
                  T(t.title),
                  1
                  /* TEXT */
                )
              ])
            ],
            2
            /* CLASS */
          ),
          n(r.$slots, "icon", { isActive: e(l) }, () => [
            C(e(O), {
              class: s(e(I))
            }, {
              default: y(() => [
                (v(), V(F(t.icon)))
              ]),
              _: 1
              /* STABLE */
            }, 8, ["class"])
          ])
        ], 42, j),
        C(e(z), null, {
          default: y(() => [
            H(a("div", {
              id: e(d),
              role: "region",
              class: s(e(E)),
              "aria-hidden": !e(l),
              "aria-labelledby": e(f)
            }, [
              a(
                "div",
                {
                  class: s(e(B))
                },
                [
                  n(r.$slots, "default")
                ],
                2
                /* CLASS */
              )
            ], 10, q), [
              [M, e(l)]
            ])
          ]),
          _: 3
          /* FORWARDED */
        })
      ],
      2
      /* CLASS */
    ));
  }
});
export {
  U as default
};
